export default __webpack_public_path__ + "static/media/vote_proxy_3.3ea6e799.jpg";